import { render, staticRenderFns } from "./StoreTile.vue?vue&type=template&id=126924e7&"
import script from "./StoreTile.vue?vue&type=script&lang=js&"
export * from "./StoreTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports